import { cn } from '@/utils/tailwind';

export const LayoutOrderColumn = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  // flex-1/min-h-0: empty 오버레이(absolute inset-0)의 기준 부모를 흰 영역 전체 높이로 만들어
  // 아이콘+문구가 정중앙에 오게 한다. 데이터가 있으면 콘텐츠 높이대로 동작한다.
  return (
    <div className={cn('flex w-full min-w-0 max-w-full flex-1 flex-col', 'min-h-0', className)}>
      {children}
    </div>
  );
};
